/**
 * Motivo da reprovação do termo (#6331). A Análise Cadastral reprova por três
 * caminhos — crédito/decisão da análise, cliente que não confirmou na ligação e
 * ligação sem contato — e até aqui só o status ficava gravado, sem dizer qual.
 * O motivo vai junto no mesmo update que muda o status (AnaliseCadastralWizard),
 * e o Painel Executivo mostra na lista do card "Termo Reprovado".
 *
 * Função pura, sem I/O: roda sob `node --test` com type-stripping.
 */

export type MotivoReprovacao = 'analise' | 'nao_confirmou' | 'sem_contato';

export const ROTULO_MOTIVO_REPROVACAO: Record<MotivoReprovacao, string> = {
  analise: 'Reprovado na análise',
  nao_confirmou: 'Não confirmou na ligação',
  sem_contato: 'Ligação sem contato',
};

/**
 * Mesma ordem de decisão do AnaliseCadastralWizard: a verificação telefônica
 * pesa antes da decisão da análise. `null` quando o resultado não reprova.
 */
export function motivoDaReprovacao(
  verificacao: string | null | undefined,
  decisaoFinal: string | null | undefined,
): MotivoReprovacao | null {
  if (verificacao === 'confirmado' && (decisaoFinal === 'Aprovado' || decisaoFinal === 'Aprovado com Ressalvas')) return null;
  if (verificacao === 'nao_confirmou') return 'nao_confirmou';
  if (verificacao === 'numero_errado' || verificacao === 'sem_resposta') return 'sem_contato';
  if (decisaoFinal === 'Reprovado') return 'analise';
  return null;
}

/** Texto para a tela; motivo antigo ou de marcação manual vira "Não informado". */
export function rotuloMotivoReprovacao(motivo: string | null | undefined): string {
  // hasOwn: 'toString', '__proto__' & cia. viriam do protótipo e sairiam como texto estranho.
  return motivo && Object.prototype.hasOwnProperty.call(ROTULO_MOTIVO_REPROVACAO, motivo)
    ? ROTULO_MOTIVO_REPROVACAO[motivo as MotivoReprovacao]
    : 'Não informado';
}
